import { render, staticRenderFns } from "./RiskRating.vue?vue&type=template&id=2aaf642a&"
import script from "./RiskRating.vue?vue&type=script&lang=js&"
export * from "./RiskRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports